/**
 * 是否在iframe之中
 */
export function isInIframe() {
    let inFrame = false;
    try {
        inFrame = window.self !== window.parent;
    } catch (e) {
        inFrame = true;
    }

    // 嵌入了第三方域名不做嵌入算, 只有同一一级域名才能设置这个
    try {
        document.domain = document.domain;
    } catch (e) {
        inFrame = false;
    }
    return inFrame;
}
